import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  type: string().oneOf(['cards', 'cards_tasks', 'cards_attachments', 'databases']).required(),
  status: string().oneOf(['pending', 'completed', 'failed']).required(),
  file_key: string().required().default(null).nullable(),
});

/**
 * ExportUpdateEvent
 *
 * - Evento emitido quando uma exportação é atualizada.
 */
export class ExportUpdateEvent extends CreateCommand(RealtimeEventType.ExportUpdate, SCHEMA) {}
